export { default as Rating } from "./rating";
